import translate from "./translate"
import type { Banner } from "./banner.types"

const maybeTranslate = (banner: Banner): string => {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!banner) return banner

  const maybeTranslated = translate(banner.text, banner.values)
  const isTranslated = maybeTranslated !== banner.text.toLowerCase()
  return isTranslated ? maybeTranslated : banner.text
}

export default maybeTranslate
